import { memo, useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

import { useUsers } from '../../contexts/users/context';
import Layout from '../../components/Layouts/Layout';
import CertificateCard from './CertificateCard';
import { GetAllCertificatesResponse } from '../../interfaces/user';

const classes = {
  pageTitle: {
    fontSize: '32px',
    fontWeight: 700,
    color: 'primary.main',
  },
  contentContainer: {
    paddingY: 5,
    paddingX: 7,
    display: 'flex',
    flexDirection: 'column',
    gap: { xs: 3, sm: 6 },
    height: 'auto',
  },
  loaderContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '50vh',
  },
};

const Certificates = () => {
  const { getAllCertificates } = useUsers();
  const [certificates, setCertificates] = useState<GetAllCertificatesResponse[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  const getCertificates = async () => {
    setIsLoading(true);
    const fetchedCertificates = await getAllCertificates();
    setCertificates(fetchedCertificates);
    setIsLoading(false);
  };

  useEffect(() => {
    getCertificates();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Layout>
      <Box sx={classes.contentContainer}>
        <Typography variant="h1" sx={classes.pageTitle}>
          Certificados
        </Typography>
        {isLoading ? (
          <Box sx={classes.loaderContainer}>
            <CircularProgress />
          </Box>
        ) : (
          <Grid container spacing={3}>
            {certificates.map(({ id, images, name }) => (
              <Grid item xs={12} lg={6} xl={4} key={id}>
                <CertificateCard courseId={id} image={images[0]} title={name} />
              </Grid>
            ))}
          </Grid>
        )}
      </Box>
    </Layout>
  );
};

export default memo(Certificates);
